import * as mobileMap from '../mappings/mobile_mappings';

/**
 * Brand/model display names (e.g. "Mercedes-Benz", "C 63 AMG") come in from
 * routes and search UI; the mapping tables are keyed by an uppercase,
 * underscore-separated code (e.g. `MERCEDES_BENZ`). These helpers reverse
 * that normalization.
 */

export function findBrandKey(displayName: string): string | null {
  const key = displayName.toUpperCase().replaceAll('-', '_').replaceAll(' ', '_');
  return mobileMap.MOBILE_BRANDS[key] ? key : null;
}

export function findModelKey(brandKey: string, displayName: string): string | null {
  const brandModels = mobileMap.MOBILE_MODELS[brandKey];
  if (!brandModels) {
    return null;
  }

  const directKey = displayName.toUpperCase().replaceAll(' ', '_');
  if (brandModels[directKey]) {
    return directKey;
  }

  const brandVariations = mobileMap.MOBILE_VARIATIONS[brandKey] ?? {};
  for (const [modelKey, variations] of Object.entries(brandVariations)) {
    if (variations.includes(displayName)) {
      return modelKey;
    }
  }

  return null;
}
